import { TGoogleFontCategory } from './briefFontSelection.types'

interface IBriefFontSelectionNav {
  categories: TGoogleFontCategory[]
  activeCategory: TGoogleFontCategory
  onSelect: (category) => void
}

export function BriefFontSelectionNav({
  categories,
  activeCategory,
  onSelect,
}: IBriefFontSelectionNav) {
  return (
    <div className="flex flex-wrap items-center justify-start mb-6 overflow-scroll border-b border-core-grey-50 no-scrollbar">
      {categories.map((categoryName) => {
        return (
          <button
            key={categoryName}
            className={`py-3 mr-10 text-xl leading-none capitalize first:ml-0 whitespace-nowrap ${
              activeCategory === categoryName
                ? 'border-b-2 border-core-grey-100 text-core-grey-100 -mb-[1px] pb-[6.5px]'
                : 'text-core-grey-70'
            }`}
            onClick={() => onSelect(categoryName)}
          >
            {categoryName}
          </button>
        )
      })}
    </div>
  )
}
